import {
	ST2FAStatusResponse,
	STAuthChangePassword,
	STAuthDisable2FAAuth,
	STAuthGenerateBackupCodes,
	STAuthRegister,
	STAuthResetPassword,
	STAuthSendResetPasswordEmail,
	STAuthUserLogin,
	STAuthVerifyAndEnable2FAAuth,
	STAuthVerifyTOTP,
} from "api/authApi/types";

import HttpClient from "api/index";
import {getItem} from "helpers/localStorage";
import {AxiosResponse} from "axios";

class AuthApi extends HttpClient {
	async login(userData: STAuthUserLogin) {
		userData = {...userData, grant_type: "password"};

		return this.doPost("/auth/login", userData);
	}

	async logout() {
		const refreshToken = getItem("refresh_token");

		return this.doPost("/auth/logout", refreshToken ? {refresh_token: refreshToken} : {});
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	async logoutBulk() {
		return this.doPost("/auth/logout/bulk");
	}

	async getUser() {
		return this.doGet("/user/profile");
	}

	async getUserChannel() {
		return this.doGet("/channels/user");
	}

	async getUserStats(config = {}) {
		return this.doGet("/user/stats", config);
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	async getUserName({email}: any) {
		return this.doGet(`/auth/get_username?email_address=${email}`);
	}

	async getLicenseTypes() {
		return this.doGet("/license-types");
	}

	async verifyEmail(formData: STAuthSendResetPasswordEmail, config = {}) {
		return this.doPost("/auth/send-reset-password-email", formData, config);
	}

	async resetPassword(formData: STAuthResetPassword, config = {}) {
		return this.doPost(`/auth/reset-password`, formData, config);
	}

	async changePassword(formData: STAuthChangePassword, config = {}) {
		return this.doPost("/auth/change-password", formData, config);
	}

	async register(formData: STAuthRegister, config = {}) {
		return this.doPost("/auth/register", formData, config);
	}

	async verifyVerificationCode(verificationCode: string) {
		return this.doGet(`/verification-codes/${verificationCode}`);
	}

	async sendVerificationEmail(
		email: string,
		params?: {payment_url: string; payment_interval: string},
	) {
		return this.doPost("/auth/send-verification-email", {email, ...params});
	}

	async enable2FAAuth(form: {password: string}, config = {}) {
		return this.doPost("/auth/2fa/enable", form, config);
	}

	async disable2FAAuth(formData: STAuthDisable2FAAuth, config = {}) {
		return this.doPost("/auth/2fa/disable", formData, config);
	}

	async get2FAAuthStatus(): Promise<AxiosResponse<ST2FAStatusResponse>> {
		return this.doGet<ST2FAStatusResponse>("/auth/2fa/status");
	}

	async generateBackupCodes(formData: STAuthGenerateBackupCodes, config = {}) {
		return this.doPost("/auth/2fa/regenerate-backup-codes", formData, config);
	}

	async verify2FAAuth(formData: STAuthVerifyTOTP, config = {}) {
		return this.doPost("/auth/2fa/verify", formData, config);
	}

	async verifyNEnable2FAAuth(formData: STAuthVerifyAndEnable2FAAuth, config = {}) {
		return this.doPost("/auth/2fa/verify-and-enable", formData, config);
	}
}

const index = new AuthApi();

export default index;
